function _decodeBasicEntities(text: string): string {
  return text
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, ' ')
    .replace(/&mdash;/g, '—')
    .replace(/&ndash;/g, '–')
    .replace(/&hellip;/g, '…');
}

export function decodeHtmlEntities(value: string | null | undefined): string {
  if (!value) return '';
  if (typeof DOMParser === 'undefined') return _decodeBasicEntities(String(value));
  const doc = new DOMParser().parseFromString(String(value), 'text/html');
  return doc.documentElement.textContent ?? String(value);
}

export function stripHtml(value: string | null | undefined): string {
  if (!value) return '';
  if (typeof DOMParser === 'undefined') {
    return _decodeBasicEntities(String(value).replace(/<[^>]*>/g, '')).trim();
  }
  const doc = new DOMParser().parseFromString(String(value), 'text/html');
  return (doc.body.textContent || '').trim();
}

function _httpUrl(value: string): URL | null {
  try {
    const url = new URL(value);
    if (url.protocol === 'http:' || url.protocol === 'https:') return url;
  } catch {
    return null;
  }
  return null;
}

/**
 * An href safe to hand to the browser, or undefined when the value isn't one.
 *
 * Every URL Kingfisher renders is third-party: it arrives from a feed, a page
 * we fetched, or a link a curator pasted. URLs rendered in row chrome
 * (story.url, linked_url, feed_url, canonical_url) must be restricted to
 * http(s), since a `javascript:` value could run with the session's privileges.
 * An `href` that takes an ingested URL should route through here.
 *
 * Returns undefined rather than '' or '#': React drops the attribute entirely,
 * so the anchor renders as inert text instead of a link to the current page.
 */
export function safeHref(value: string | null | undefined): string | undefined {
  if (!value) return undefined;
  return _httpUrl(String(value))?.href;
}

